import { render, staticRenderFns } from "./index.vue?vue&type=template&id=51a71654&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "bh-mod/styles/filemanager/files.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=51a71654&prod&lang=css"
import style2 from "./index.vue?vue&type=style&index=2&id=51a71654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a71654",
  null
  
)

export default component.exports